import { render, staticRenderFns } from "./Teleprompter.vue?vue&type=template&id=ce8dfeb4&scoped=true&"
import script from "./Teleprompter.vue?vue&type=script&lang=js&"
export * from "./Teleprompter.vue?vue&type=script&lang=js&"
import style0 from "./Teleprompter.vue?vue&type=style&index=0&id=ce8dfeb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8dfeb4",
  null
  
)

export default component.exports